"use client";

import Script from "next/script";

const configuredProjectId =
	process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID?.trim() ?? "";
const projectId = /^[a-z0-9]+$/i.test(configuredProjectId)
	? configuredProjectId
	: null;

export function MicrosoftClarity() {
	if (!projectId) return null;

	return (
		<Script
			id="microsoft-clarity"
			strategy="afterInteractive"
			// biome-ignore lint/security/noDangerouslySetInnerHtml: Clarity requires its queued loader snippet.
			dangerouslySetInnerHTML={{
				__html: `
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            var consent='denied';
            try {
              consent=c.localStorage.getItem('cookie_consent')==='accepted'
                ? 'granted'
                : 'denied';
            } catch {}
            c[a]('consentv2',{
              ad_Storage:consent,
              analytics_Storage:consent
            });
            t=l.createElement(r);t.async=1;t.src='https://www.clarity.ms/tag/'+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window,document,'clarity','script','${projectId}');
        `,
			}}
		/>
	);
}
